import { Navbar, Container, Nav, NavDropdown } from "react-bootstrap";
import React, { useState } from "react";
import logo from "../high_res_logo.png";
import { Link, useNavigate } from "react-router-dom";
import { auth } from "../firebase";
import { signOut } from "firebase/auth";
import { useContext } from "react";
import { UserContext } from "../providers/UserProvider";
import cjflogo from "../cjf_logo.jpg";

const MyNavbar = () => {
  const { data2 } = useContext(UserContext);
  const navigate = useNavigate();
  const [show, setShow] = useState(false);
  const [show2, setShow2] = useState(false);
  const showDropdown = (e) => {
    setShow(!show);
  };
  const hideDropdown = (e) => {
    setShow(false);
  };
  const showDropdown2 = (e) => {
    setShow2(!show2);
  };
  const hideDropdown2 = (e) => {
    setShow2(false);
  };

  const structuredLessonIds = [
    "ScyF4p5IWmW0W1nN3jdu",
    "ltmdjbUAhX827TpQZrbq",
    "33w5lRGDmjeDbiZhVvuI",
    "Lr9JFFnnTg8KY5forR28",
  ];

  const showImages = false;
  const logout = (e) => {
    signOut(auth)
      .then(() => {
        // Sign-out successful.
      })
      .catch((error) => {
        // An error happened.
      });
  };

  const goBack = () => {
    navigate(-1);
  };

  return (
    <Navbar expand="lg" collapseOnSelect className="de-navbar">
      <Container className="navbar-container">
        <Navbar.Brand onClick={() => goBack()} className="" eventKey={0}>
          <span className="material-symbols-outlined return_arrow text-white">
            arrow_back
          </span>
        </Navbar.Brand>
        <Navbar.Brand as={Link} to="/">
          <img
            alt=""
            src={"icons/logo_white.png"}
            width="100"
            height="50"
            className="d-inline-block align-top"
          />{" "}
        </Navbar.Brand>
        <Navbar.Toggle aria-controls="basic-navbar-nav" />
        <Navbar.Collapse
          id="basic-navbar-nav"
          className="justify-content-end my-auto text-center"
        >
          <Nav fill className="align-items-center">
            <Nav.Item className="">
              <Nav.Link as={Link} to="/" eventKey={3}>
                {showImages ? (
                  <img
                    alt="Lessons"
                    title="Lessons"
                    src="/icons/icon_group.png"
                    width="65"
                    height="65"
                    style={
                      {
                        // marginTop: -5,
                        // marginBottom: -10,
                        // marginRight: -5,
                        // marginLeft: -5,
                      }
                    }
                  ></img>
                ) : (
                  <></>
                )}
                <div className="de-navbar-text">Class Groups</div>
              </Nav.Link>
            </Nav.Item>

            <NavDropdown
              title="Curriculum"
              id="collasible-nav-dropdown"
              className="de-navbar-text"
              show={show}
              onMouseEnter={showDropdown}
              onMouseLeave={hideDropdown}
              onClick={(e) => {
                if (e.target.id === "collasible-nav-dropdown") {
                  navigate("/curriculum");
                }
              }}
            >
              <NavDropdown.Item
                style={{}}
                as={Link}
                to={`/structured-lessons/${structuredLessonIds[data2.Year]}`}
              >
                <div className="tabbar-text-computer">PE Plans</div>
              </NavDropdown.Item>
              <NavDropdown.Item as={Link} to="/lessons">
                <div className="tabbar-text-computer">Strands</div>
              </NavDropdown.Item>
              <NavDropdown.Item style={{}} as={Link} to="/movement-breaks">
                <div className="tabbar-text-computer">Movement Breaks</div>
              </NavDropdown.Item>
            </NavDropdown>

            <Nav.Item>
              <Nav.Link as={Link} to="/schedule" eventKey={4}>
                {showImages ? (
                  <img
                    alt="Schedule"
                    title="Schedule"
                    src="/icons/icon_schedule.png"
                    width="45"
                    height="45"
                    style={{
                      marginBottom: 8,
                    }}
                  ></img>
                ) : (
                  <></>
                )}
                <div className="de-navbar-text">PE Planner</div>
              </Nav.Link>
            </Nav.Item>

            <Nav.Item>
              <Nav.Link as={Link} to="/search" eventKey={7}>
                {showImages ? (
                  <img
                    title="Homework"
                    src="/icons/icon_search.png"
                    width="65"
                    height="45"
                    style={{
                      // marginTop: 5,
                      marginBottom: 10,
                      // marginRight: -10,
                      // marginLeft: -15,
                    }}
                  ></img>
                ) : (
                  <></>
                )}
                <div className="de-navbar-text">Search</div>
              </Nav.Link>
            </Nav.Item>

            <NavDropdown
              className="de-navbar-text"
              title="More"
              id="basic-nav-dropdown"
              show={show2}
              onMouseEnter={showDropdown2}
              onMouseLeave={hideDropdown2}
            >
              <NavDropdown.Item as={Link} to="/account" eventKey={8}>
                <div className="tabbar-text-computer"> My Account</div>
              </NavDropdown.Item>
              {data2 && data2.SchoolID.length > 0 ? (
                <NavDropdown.Item
                  as={Link}
                  to="/manage-school/school"
                  eventKey={9}
                >
                  <div className="tabbar-text-computer"> My School</div>
                </NavDropdown.Item>
              ) : (
                <></>
              )}

              <NavDropdown.Divider />
              <NavDropdown.Item
                as={Link}
                to="/login"
                onClick={logout}
                eventKey={10}
              >
                <div className="tabbar-text-computer">Logout</div>
              </NavDropdown.Item>

              {data2?.Guid === "j74ZyWsM3Yg8snPpsjyfKZXb6BJ2" ||
              data2.Guid === "bUNhMhxJiPS6Fz74LIbkYpomVK32" ? (
                <div>
                  <NavDropdown.Divider />
                  <NavDropdown.Item
                    as={Link}
                    to="/content-management"
                    eventKey={11}
                  >
                    <div className="tabbar-text-computer">
                      Content Management
                    </div>
                  </NavDropdown.Item>
                  <NavDropdown.Item as={Link} to="/analytics" eventKey={12}>
                    <div className="tabbar-text-computer">Analytics</div>
                  </NavDropdown.Item>
                </div>
              ) : (
                <></>
              )}
            </NavDropdown>
          </Nav>
        </Navbar.Collapse>
      </Container>
    </Navbar>
  );
};

export default MyNavbar;
